import React, { useEffect, useState } from "react";
import { Drawer, Collapse, Timeline, Popover, Modal, Form, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Get_Output_History_list_Action_Handler } from "../../../Redux/Actions/user/OutputListEditHistoryRunQa";
import {
  Rename_Title_edit_History_Action_Handler,
  Rename_Title_edit_History_Success,
} from "../../../Redux/Actions/user/RenameTitleEditHistoryRunQa";
import Loader from "../../../Components/Loader/Loader";

const EditHistoryDrawer = ({
  setRestoreData,
  openEditHistory,
  closeEditHistoryDrawer,
  callRestoreApi,
  isRestored,
  QaID,
  ActionId,
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [QaHistoryData, setQaHistoryData] = useState([]);
  const [historyId, setHistotyId] = useState("");

  const QaHistoryDataRed = useSelector(
    (state) =>
      state?.Output_ListEditHistory_RunQa_Data?.Output_history_list_data
  );
  const QaHistoryDataLoader = useSelector(
    (state) => state?.Output_ListEditHistory_RunQa_Data?.loader
  );

  const QaRenameHistoryData = useSelector(
    (state) =>
      state?.Rename_TitleEditHistory_RunQa_Data?.Rename_title_editHistory_data
  );

  useEffect(() => {
    if (QaHistoryDataRed) {
      setQaHistoryData(QaHistoryDataRed?.data);
    }
  }, [QaHistoryDataRed]);

  useEffect(() => {
    if (QaID && ActionId) {
      const timeoutId = setTimeout(() => {
        dispatch(Get_Output_History_list_Action_Handler(QaID, ActionId));
      }, 1000); // 1000 milliseconds = 1 second

      return () => clearTimeout(timeoutId);
    }
  }, [QaID, ActionId, QaRenameHistoryData, isRestored]);

  useEffect(() => {
    if (QaRenameHistoryData) {
      setTimeout(() => {
        dispatch(Rename_Title_edit_History_Success(null));
        setHistotyId("");
      }, 4000);
    }
  }, [QaRenameHistoryData]);

  const formatDate = (dateString, status) => {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const timeOptions = {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    const formattedTime = date.toLocaleTimeString("en-US", timeOptions);
    return `${formattedDate} ${status ? formattedTime : ""}`;
  };

  const transformData = () => {
    const entries = Object.entries(QaHistoryData);
    const transformed = entries.map(([date, events], index) => ({
      key: String(index + 1),
      label: formatDate(date, false),
      events: events.map((event) => ({
        id: event?.id,
        title: event.title,
        summary: event.description || "No summary available",
        time: formatDate(event.created_at, true),
        edited_output: event?.edited_output,
        actions: ["Rename", "Restore"],
      })),
    }));

    return transformed;
  };

  const onFinish = (value) => {
    if (QaID && ActionId && value) {
      dispatch(
        Rename_Title_edit_History_Action_Handler(
          value,
          QaID,
          ActionId,
          historyId
        )
      );
      form.resetFields();
      setIsModalVisible(false);
    }
  };

  return (
    <div>
      {/* {QaHistoryDataLoader && (
        <div className="temportal-loader-overlay-2">
          <div className="temporal-loader"></div>
        </div>
      )} */}
      <div className="drawer-backround-visible">
        <Drawer
          closable={false}
          className="drawer-backround-visible"
          title="Edit History"
          onClose={closeEditHistoryDrawer}
          open={openEditHistory}
          placement={"left"}
          width={"25%"}
          maskClosable={false}
          mask={false}
        >
          <img
            className="supporting-document-modal-sideClose"
            src="/assets/ModalClose.svg"
            alt=""
            onClick={closeEditHistoryDrawer}
          />
          <h1>Edit History</h1>
          <div>
            <Collapse defaultActiveKey={["1"]} bordered={false} ghost>
              {transformData()?.map((item) => (
                <Collapse.Panel header={item.label} key={item.key}>
                  <Timeline>
                    {item.events.map((event, index) => (
                      <Timeline.Item key={index}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
                          <div>
                            <div className="font-semibold">{event.title}</div>
                            <div className="text-sm">
                              {event.summary && (
                                <div className="text-zinc-500">
                                  {event.summary}
                                </div>
                              )}
                              <div className="text-zinc-500">{event.time}</div>
                            </div>
                          </div>
                          <Popover
                            placement="bottomRight"
                            content={
                              <div>
                                <div
                                  className="edited-history-conetnt-popover "
                                  onClick={() => {
                                    setIsModalVisible(true);
                                    setHistotyId(event?.id);
                                  }}
                                >
                                  Rename
                                </div>
                                <div
                                  className="edited-history-conetnt-popover"
                                  onClick={() => {
                                    callRestoreApi(
                                      event?.id,
                                      event?.edited_output
                                    );
                                  }}
                                >
                                  Restore
                                </div>
                              </div>
                            }
                            className="popover-new-build"
                          >
                            <img
                              src="/assets/dot.svg"
                              alt="dotIcon"
                              height={20}
                              width={20}
                              style={{
                                cursor: "pointer",
                              }}
                              className="vertical-img-logo"
                            />
                          </Popover>
                        </div>
                      </Timeline.Item>
                    ))}
                  </Timeline>
                </Collapse.Panel>
              ))}
            </Collapse>
          </div>
          {/* <div className="m-auto" style={{ marginTop: "30px" }}>
            <button className="view_edit_history">View Olders</button>
          </div> */}
        </Drawer>
      </div>

      <Modal
        title="Update History Name"
        visible={isModalVisible}
        onOk={() => form.submit()}
        onCancel={() => setIsModalVisible(false)}
        className="user-management-modal"
      >
        <Form form={form} onFinish={onFinish}>
          <Form.Item
            label="Enter Name"
            name="title"
            rules={[
              {
                required: true,
                message: "Please input the name!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item>
            <button type="submit" className="model-btn-submit-management">
              Update
            </button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default EditHistoryDrawer;
